import { lazy } from "react";

export type { IAddToNicheConfirm } from "./types";

export const AddToNicheConfirm = lazy(() => import("./AddToNicheConfirm"));
